'use client';

import { useReadContract } from 'wagmi';
import { erc20Abi } from 'viem';
import type { Address } from 'viem';
import { ChainType } from '@/constants/chain-specific';
import { formatUnits } from 'viem';
interface UseLPTokenBalanceProps {
  lpTokenAddress?: Address;
  userAddress?: Address;
  chainId?: ChainType;
  enabled?: boolean;
}
export function useLPTokenBalance({
  lpTokenAddress,
  userAddress,
  chainId,
  enabled = true
}: UseLPTokenBalanceProps) {
  const {
    data: balance,
    isLoading,
    error,
    refetch
  } = useReadContract({
    address: lpTokenAddress,
    abi: erc20Abi,
    functionName: 'balanceOf',
    args: userAddress ? [userAddress] : undefined,
    chainId: chainId ? Number(chainId) : undefined,
    query: {
      enabled: enabled && !!lpTokenAddress && !!userAddress && !!chainId,
      refetchInterval: 30000 // Refetch every 30 seconds
    }
  });
  const {
    data: decimals,
    isLoading: isDecimalsLoading
  } = useReadContract({
    address: lpTokenAddress,
    abi: erc20Abi,
    functionName: 'decimals',
    chainId: chainId ? Number(chainId) : undefined,
    query: {
      enabled: enabled && !!lpTokenAddress && !!chainId
    }
  });
  const formattedBalance = balance && decimals ? formatUnits(balance, decimals) : '0';
  return {
    balance: balance || 0n,
    formattedBalance,
    decimals: decimals || 18,
    isLoading: isLoading || isDecimalsLoading,
    error,
    refetch
  };
}